/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VendorAuctionWorksheetAttachmentDto } from '../../models/vendor-auction-worksheet-attachment-dto';

export interface ApiVendorVendorAuctionGetVendorAttachmentGet$Params {
  auctionId?: string;
  vendorId?: string;

/**
 * User's Working Group
 */
  UserWorkingGroup?: String;
}

export function apiVendorVendorAuctionGetVendorAttachmentGet(http: HttpClient, rootUrl: string, params?: ApiVendorVendorAuctionGetVendorAttachmentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<VendorAuctionWorksheetAttachmentDto>>> {
  const rb = new RequestBuilder(rootUrl, apiVendorVendorAuctionGetVendorAttachmentGet.PATH, 'get');
  if (params) {
    rb.query('auctionId', params.auctionId, {});
    rb.query('vendorId', params.vendorId, {});
    rb.header('UserWorkingGroup', params.UserWorkingGroup, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<VendorAuctionWorksheetAttachmentDto>>;
    })
  );
}

apiVendorVendorAuctionGetVendorAttachmentGet.PATH = '/api/vendor/vendor-auction/GetVendorAttachment';
